module.exports = __webpack_public_path__ + "img/start-icon.8a3c314d.svg";